import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { RouteUtilsService } from '@lassi/webapp-shared';
import { map, switchMap } from 'rxjs';
import { NavButtonItem } from './nav-button-base';

@Component({
  selector: 'lassi-nav-button',
  imports: [MatButton, MatIcon, RouterModule],
  template: `
    <button
      [attr.data-testid]="item().id"
      mat-button
      [routerLink]="routerLink()"
      queryParamsHandling="merge"
      [class.active]="isActive()"
      [info]="{
        restore: true,
      }"
    >
      <div>
        <div class="icon-container" [class.no-label]="!item().label">
          @if (item().isSvgIcon) {
            <mat-icon class="centered-svg-icon" [svgIcon]="item().icon" />
          } @else {
            <mat-icon>{{ item().icon }}</mat-icon>
          }
        </div>
        <span>{{ item().label }}</span>
      </div>
    </button>
  `,
  styles: `
    @use 'navbar' as *;

    @include navbar-button;
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavButtonComponent {
  item = input.required<NavButtonItem>();

  private readonly routeUtils = inject(RouteUtilsService);

  isActive$ = toObservable(this.item).pipe(
    map((item) => item.name),
    switchMap((path) =>
      this.routeUtils
        .isDrawerPageActive(path.split('/'))
        .pipe(map((isActive) => ({ isActive, path }))),
    ),
  );

  isActive = toSignal(this.isActive$.pipe(map(({ isActive }) => isActive)));

  routerLink = toSignal(
    this.isActive$.pipe(
      map(({ isActive, path }) =>
        isActive
          ? ['.']
          : [
              {
                outlets: {
                  [RouteUtilsService.MAP_MENU_OUTLET_NAME]: [
                    RouteUtilsService.MAP_MENU_ROOT_PATH,
                    ...path.split('/'),
                  ],
                },
              },
            ],
      ),
    ),
  );
}
